/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ContinueSocialLoginBody = zod.object({
  flowId: zod.string().min(1),
});

export type ContinueSocialLoginBody = zod.input<typeof ContinueSocialLoginBody>;
export type ContinueSocialLoginBodyOutput = zod.output<typeof ContinueSocialLoginBody>;
